module.exports = __webpack_public_path__ + "img/badge-promoted.28d7124.svg";